import { SelectData } from "@/types/typesInterfaces";

// utils/helpers.ts
export function deepMerge(target: any, source: any) {
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
}

function isObject(item: any): boolean {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export const beautifyDuration = (tCommon: any, value: number, measure: string): string => {
  let returnValue = value.toString();

  const convertedMeasure: string | null = convertMeasure(tCommon, measure);
  if (convertedMeasure != null) {
    returnValue += " " + convertedMeasure;
  }

  return returnValue;
}

export const convertMeasure = (tCommon: any, measure: string): string | null => {
  switch (measure) {
    case 'Y':
      return tCommon.raw('date').years;
    case 'M':
      return tCommon.raw('date').months;
    case 'D':
      return tCommon.raw('date').days;
    case 'H':
      return tCommon.raw('date').hours;
    case 'm':
      return tCommon.raw('date').minutes;
  }

  return null;
}


export function calculateMonthlyPayment(amount: number, years: number, interest: number) {
  const n: number = years * 12;
  const i: number = interest / 100 / 12;

  if (i === 0) {
    return amount / n;
  }

  return (amount * i) / (1 - Math.pow(1 + i, -n));
}

export const selectOnSeach = (value: SelectData | any, dataList: SelectData | any, onChange?: (e: SelectData | any) => void, key: string = "label") => {
  console.log('*** SEARCH ', value)
  const filterStr = ('' + value).toLowerCase() as string;

  let filtered = dataList;
  if (filterStr !== '') {
    filtered = dataList.filter((el: SelectData) => {
      const fieldValue = (el[key as keyof SelectData] ?? '').toString().toLowerCase();
      return fieldValue.includes(filterStr);
    });

    if (filtered.length === 1 && onChange) {
      onChange(filtered[0]);
    }

    filtered = filtered.length > 0
      ? filtered
      : [{ [key]: "Nessun risultato trovato", value: null }];
  }

  return filtered;
}

export const getDateTimeCache = (granularity: string = 'MM'): string => {

  // YYYY-MM-DDTHH:mm:ss
  const lengths: Record<string, number> = {
    YYYY: 4,
    MM: 7,
    DD: 10,
    HH: 13,
    mm: 16,
    ss: 19
  };

  const sliceGranularity: number = process.env.APP_ENV !== 'production' ? lengths.mm : lengths[granularity] ?? lengths.ss;

  return new Date()
    .toISOString()
    .slice(0, sliceGranularity)
    .replace(/[-T:]/g, '');
}